import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

// Persistent in-app banner for members targeted by an active re-verification campaign.
// Dismissible PER SESSION (sessionStorage) but it returns on the next login/session until they
// verify — never dismissed-forever. Driven by GET /api/me/verify-prompt. CTA routes to /verify.
const KEY = "os_verify_campaign_dismissed";

export default function CampaignVerifyBanner() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem(KEY) === "1");

  useEffect(() => {
    if (!user || user.identity_verified) { setShow(false); return; }
    api.get("/me/verify-prompt").then(({ data }) => setShow(!!data.show)).catch(() => setShow(false));
  }, [user]);

  if (!user || user.identity_verified || !show || dismissed) return null;
  // RE-VERIFY MERGE: never stack two verify prompts. If the reset-badge ReverifyBanner is already
  // showing (reverify_required), it owns the message — suppress this campaign banner.
  if (user.reverify_required) return null;
  return (
    <div role="status" data-testid="campaign-verify-banner"
      className="w-full bg-[#d3a24e]/15 border-b border-[#d3a24e]/40 text-foreground px-4 py-2.5 flex flex-col sm:flex-row items-center justify-center gap-x-3 gap-y-1.5 text-center">
      <span className="inline-flex items-center gap-2 font-mono text-xs sm:text-sm leading-tight">
        <ShieldCheck className="w-4 h-4 text-[#d3a24e] shrink-0" />
        Verify your ID to unlock listing, selling and getting paid. It's a quick platform-wide step — about two minutes.
      </span>
      <button onClick={() => navigate("/verify")} data-testid="campaign-verify-cta"
        className="shrink-0 bg-[#d3a24e] text-black font-heading font-bold uppercase text-xs px-4 py-1.5 hover:bg-[#d3a24e]/90 transition-colors">
        Verify my ID
      </button>
      <button onClick={() => { sessionStorage.setItem(KEY, "1"); setDismissed(true); }} data-testid="campaign-verify-dismiss"
        className="shrink-0 font-mono uppercase text-[10px] text-muted-foreground hover:text-foreground transition-colors">
        Not now
      </button>
    </div>
  );
}
